// extracted by mini-css-extract-plugin
export default {"exercises":"exercise-list_exercises__os3-q","exercises__no-content":"exercise-list_exercises__no-content__xUy2O","exercises__list":"exercise-list_exercises__list__NzaW0"};